import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB9vZjS2bu-MlNXaVbnl89cUBB2qIXR81Q",
  authDomain: "kvittokoll-6f304.firebaseapp.com",
  projectId: "kvittokoll-6f304",
  storageBucket: "kvittokoll-6f304.firebasestorage.app",
  messagingSenderId: "63417782957",
  appId: "1:63417782957:web:7994a128f8b3c7d7d7ac24"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);